import { Flex, Group, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { PresentationValidationAction } from '@/module/Author/Presentation/Validation/PresentationValidationAction';
import { PresentationValidationHistory } from '@/module/Author/Presentation/Validation/PresentationValidationHistory';
import { PresentationDeleteButton } from '@/module/Author/Presentation/components/PresentationDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { PresentationProofAction } from './Proof';
import { Presentation } from './model/PresentationTypes';

interface PresentationViewProps {
  presentation: Presentation;
}

export function PresentationView(props: PresentationViewProps) {
  const { presentation } = props;
  const { title, conference, link, authors } = presentation;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{title}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <PresentationDeleteButton presentationId={presentation.id} />
            </Group>
          </Flex>
          <Text size="sm">{conference?.conferenceName ?? '-'}</Text>
          <Text
            c="dimmed"
            size="xs"
          >
            {conference?.confStartDate} - {conference?.confEndDate}
          </Text>
          <Text size="sm">
            Link:{' '}
            <Link
              to={link}
              target="_blank"
            >
              {link}
            </Link>
          </Text>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <PresentationProofAction
        presentationId={presentation.id}
        authors={authors}
      />
      <PresentationValidationAction presentationId={presentation.id} />
      <PresentationValidationHistory presentationId={presentation.id} />
    </Stack>
  );
}
